export const TYPE_TEXT = 'chat'
export const TYPE_IMAGE = 'image'
export const TYPE_ATTACHMENT = 'attachment'
export const TYPE_TEMPORARY = 'tmp'